import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../app/store';
import ISUMLoginState from './sum-state.interface';

interface SUMState {
  [id: string]: ISUMLoginState;
}

const initialState: SUMState = {};

const SUMSlice = createSlice({
  name: 'sum',
  initialState,
  reducers: {
    loginSUM: (
      state,
      action: PayloadAction<{
        id: string;
        config: { metaData?: { variables?: any[] } };
      }>
    ) => {
      const { id, config } = action.payload;
      const variables = config?.metaData?.variables || [];

      state[id] = {
        userIdentification: variables.find(x => x.variableName == '$:var_[PD]_owner_user_id!')?.value || '',
        entityIdentification: variables.find(x => x.variableName == '$:var_[PD]_entity_id!')?.value || '',
        accessToken: variables.find(x => x.variableName == '$:var_[PD]_access_token!')?.value || '',
        userLastConnection: '',
        entityStatus: '',
        requiredPasswordUpdate: false,
        userIsActive: false,
        userAccountStatus: '',
      };
    },

    setEntityToken: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;
      if (state[id]) {
        const exp = new Date();
        exp.setDate(exp.getDate() + 7);

        localStorage.setItem(`LB_SUM_token_${id}`, JSON.stringify({ ...state[id], exp }));
      }
    },

    logoutSUM: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;
      delete state[id];
    },
  },
});

export default SUMSlice.reducer;

export const { loginSUM, logoutSUM, setEntityToken } = SUMSlice.actions;

export const selectSUMEntityIdentification = (state: RootState, id: string) => state.sumState[id]?.entityIdentification;
